<div class="commission">
	<h2 class="headline">
		{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.TITLE" | translate }}
	</h2>
	<div *ngIf="percentData?.length; else emptyData"
		class="scroll-block">
		<div class="table">
			<div class="table-head">
				<div class="table__row">
					<div class="column table__row-head">
						{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.SUM_FROM" | translate }}
					</div>
					<div class="column table__row-head">
						{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.SUM_TO" | translate }}
					</div>
					<div class="column table__row-head">
						{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.TYPE" | translate }}
					</div>
					<div class="column table__row-head">
						{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.SIZE" | translate }}
					</div>
					<div class="column table__row-head">
						{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.MIN_COMMISSION" | translate }}
					</div>
					<div class="column sortable table__row-head">
						{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.IS_DEFAULT" | translate }}
						<div class="info-btn">
							<img class="info-btn__icon"
								src="assets/img/Info.svg"
								alt>
							<span class="info-btn__tooltip">
								{{
                "VIRTUAL_POS_PAGE.MODAL_PERCENT.HINT" | translate
              }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div #tableBody
				class="table-body">
				<div *ngFor="let item of percentData"
					class="table__row">
					<div class="column table__row-data">{{ item.sum_from }}</div>
					<div class="column table__row-data">{{ item.sum_to }}</div>
					<div class="column table__row-data">
						{{
              "VIRTUAL_POS_PAGE.MODAL_PERCENT." + item.commission_type
                | translate
            }}
					</div>
					<div class="column table__row-data">
						{{ item.commission }}
						<span *ngIf="item.commission_type === 'Percent'">%</span>
						<span *ngIf="item.commission_type === 'Amount'">KZT</span>
					</div>
					<div class="column table__row-data">
						{{ item.min_commission }}
					</div>
					<div class="column table__row-data">
						<span class="mobile">
							{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.IS_DEFAULT" | translate }}:
						</span>
						<img *ngIf="item.is_default"
							src="assets/img/active-state.svg"
							alt="Active state"
							class="icon">
						<img *ngIf="!item.is_default"
							src="assets/img/disabled-state.svg"
							alt="Blocked state"
							class="icon">
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<ng-template #emptyData>
	<p class="description">
		{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.EMPTY_COMMISION" | translate }}
		<a routerLink="/support">
			{{ "VIRTUAL_POS_PAGE.MODAL_PERCENT.SUPPORT" | translate }}
		</a>
		.
	</p>
</ng-template>
